/**
 * IAM 治理（权限委托 + Access Review）翻译 - 中文
 */
export const iamGovernanceZh = {
  delegations: {
    title: '权限委托',
    subtitle: '临时把数据权限委托给其他同事（休假 / 出差 / 离职交接）。一级限制，禁止链式委托。',
    newButton: '新建委托',
    tabs: {
      all: '全部',
      sent: '我发起的',
      received: '我收到的',
    },
    columns: {
      from: '发起人',
      to: '受托人',
      resource: '资源',
      valid: '有效期',
      reason: '理由',
      status: '状态',
      actions: '操作',
    },
    status: {
      revoked: '已撤销',
      expired: '已过期',
      active: '活跃',
    },
    revoke: '撤销',
    revokeConfirm: '确认撤销该委托？撤销后被委托人立即失去此权限。',
    revokeFailed: '撤销失败：',
    loading: '加载中...',
    empty: '暂无委托记录',
    loadFailed: '加载失败',
    form: {
      title: '新建权限委托',
      toUser: '被委托人',
      toUserPlaceholder: '点击右侧"选择用户"',
      pickUser: '选择用户',
      pickUserTitle: '选择被委托人',
      resource: '资源（* = 全量）',
      validFrom: '开始时间',
      validTo: '结束时间',
      reason: '理由（必填）',
      reasonPlaceholder: '例：年假 2026-05-01 ~ 2026-05-07，期间审批代理',
      cancel: '取消',
      submit: '确认',
      submitting: '提交中...',
      requiredAll: '请填完整：被委托人 / 时间窗 / 理由',
      createFailed: '创建失败：',
    },
  },

  accessReview: {
    title: 'Access Review',
    subtitle: '合规要求：用户-角色绑定每 90 天内必须复核。超期项在此处理。',
    threshold: '超期阈值（天）：',
    thresholdOptions: {
      d60: '60',
      d90: '90（默认）',
      d120: '120（重点告警线）',
    },
    columns: {
      user: '用户',
      role: '角色',
      organization: '组织',
      createdAt: '创建时间',
      lastReviewed: '上次复核',
      actions: '操作',
    },
    systemLevel: '系统级（全局）',
    neverReviewed: '从未复核',
    keep: '保留',
    revoke: '撤销',
    keepDialogTitle: '复核通过 — 保留角色',
    keepDialogDesc: '该用户-角色绑定将刷新 lastReviewedAt 到当下，从超期列表移除。',
    revokeDialogTitle: '撤销角色',
    revokeDialogDesc: '该用户-角色绑定将被删除，用户立即失去该角色。请说明撤销理由。',
    commentRequired: '理由（必填）',
    commentOptional: '说明（可选）',
    keepPlaceholder: '例：定期复核，岗位职责未变',
    revokePlaceholder: '例：人员转岗 / 项目结束 / 离职',
    revokeReasonRequired: '撤销必须说明理由',
    cancel: '取消',
    confirm: '确认',
    submitting: '提交中...',
    keepFailed: '复核失败：',
    revokeFailed: '撤销失败：',
    loading: '加载中...',
    empty: '🎉 没有超期未复核的项',
    loadFailed: '加载失败：',
    unknownError: '未知错误',
  },
};
